import {
  REQUEST_EXPERT_EXPERTISE_MISSIONS,
  SET_EXPERT_EXPERTISE_MISSIONS,
  RESET_STORE_EXPERTISE,
} from 'containers/ExpertAssignedMissions/constants';

export const requestExpertExpertiseMissions = (payload: any) => ({
  type: REQUEST_EXPERT_EXPERTISE_MISSIONS,
  payload,
});

export const setExpertExpertiseMissions = (payload: any) => ({
  type: SET_EXPERT_EXPERTISE_MISSIONS,
  payload,
});

export const resetStoreExpertise = () => ({
  type: RESET_STORE_EXPERTISE,
});
